import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRootStore } from '../store/contexts/RootStoreContext';
import { reaction } from 'mobx';

export const useDocumentTitle = () => {
  const rootStore = useRootStore();
  const location = useLocation();

  useEffect(() => {
    const dispose = reaction(
      () => {
        const pathname = location.pathname;

        if (pathname === "/") {
          return rootStore.langStore.homePathLabel;
        }

        const store = rootStore.getCurrentPageStore();
        if (store && 'breadcrumbLabel' in store) {
          const breadcrumb = (store as any).breadcrumbLabel;
          if (breadcrumb) {
            return breadcrumb;
          }
        }

        const parts = pathname.split('/').filter(p => p);
        if (parts.length > 0) {
          return parts[parts.length - 1];
        }

        return rootStore.langStore.homePathLabel;
      },
      (title) => {
        if (title) {
          document.title = title;
        }
      },
      { fireImmediately: true }
    );

    return () => {
      dispose();
    };
  }, [rootStore, location]);
};
